import {useMemo} from 'react';
import {useScoringRun} from '../../context/ScoringRunContext';
import {EnrichedFields} from '../../shared/fields/enrichment';
import {AccountFields} from '../../shared/fields/keyplay';
import {getAccountIntentFieldWeights} from '../../shared/intent';
import {useCustomer} from '../../hooks/api/metadata';

export function useIntentFields({
  accountFields,
  enrichedFields,
}: {
  accountFields: AccountFields;
  enrichedFields?: EnrichedFields;
}) {
  const intentModel = useScoringRun()?.intentModels?.[0];
  const fieldDefinitions = useCustomer().fieldDefinitions;

  return useMemo(() => {
    if (!intentModel) {
      return {
        intentFields: [],
        intentModel: null,
      };
    }

    const intentFields = getAccountIntentFieldWeights({
      fieldsWithWeights: intentModel.fieldsWithWeights,
      accountFields,
      enrichedFields,
      fieldDefinitions: fieldDefinitions ?? [],
    });

    return {
      intentFields,
      intentModel,
    };
  }, [intentModel, accountFields, enrichedFields, fieldDefinitions]);
}
